import Group from "../../image/Group.png";
import dashboardIcon from "../../image/CMS_dashboard.svg"
import walletIcon from "../../image/CMS_Wallet.svg"
import usersIcon from "../../image/CMS_Users.svg"
import transactionsIcon from "../../image/CMS_Transactions.svg"
import teamsIcon from "../../image/CMS_Teams.svg"
import settingsIcon from "../../image/CMS_Settings.svg"
import serviceRequestIcon from "../../image/CMS_Service Request.svg"
import rolesIcon from "../../image/CMS_Roles.svg"
import priceGroupIcon from "../../image/CMS_Price group.svg"
import companyIcon from "../../image/CMS_Company.svg"
import chargingProfileIcon from "../../image/CMS_Charging profile.svg"
import chargersIcon from "../../image/CMS_Chargers.svg"
import authCodesIcon from "../../image/CMS_Auth Codes.svg"
import evDriversIcon from "../../image/CMS_EV Drivers.svg"
import reportIcon from "../../image/CMS_Report.svg"
import chargeZoneIcon from "../../image/CMS_ChargeZone.svg"
import MembersIcon from "../../image/members.svg";
import MapIcon from "../../image/MapPin.svg";
import ProductIcon from "../../image/productIcon.png";
import { FEATURE } from "src/util/enums";
import { getIcon, getImageIcon } from "src/utils/utility";
import promoCode from "../../image/promoCode.png";

// ----------------------------------------------------------------------

const sidebarConfig = {
  [FEATURE.DASHBOARD]: {
    title: "Dashboard",
    path: "/dashboard",
    icon: getImageIcon(dashboardIcon),
  },
  [FEATURE.CHARGER]: {
    title: "Charge Points",
    path: "/charger",
    icon: getImageIcon(chargersIcon),
  },
    [FEATURE.CHARGERPROFILE]:{
      title:"Charging Profile",
      path:"/chargingprofile",
      icon:getImageIcon(chargingProfileIcon)
    },
  [FEATURE.TEAM]: {
    title: "Teams",
    path: "/team",
    icon: getImageIcon(teamsIcon),
  },
  [FEATURE.TAG]: {
    title: "Resident RFID",
    path: "/tag",
    icon: getImageIcon(authCodesIcon),
  },
  [FEATURE.RFID_USAGE_REPORTS]: {
    title: "RFID Usage Reports",
    path: "/rfid-usage-reports",
    icon: getImageIcon(reportIcon),
  },
  [FEATURE.PRICEGROUP]: {
    title: "Price Group",
    path: "/pricegroup",
    icon: getImageIcon(priceGroupIcon),
  },
  [FEATURE.USERS]: {
    title: "CMS System User",
    path: "/users",
    icon: getImageIcon(usersIcon),
  },
  [FEATURE.TRANSACTION]: {
    title: "Transactions",
    path: "/transactions",
    icon: getImageIcon(transactionsIcon),
  },
  [FEATURE.SERVICEREQUEST]:{
    title: "Service Request",
    path:"/servicerequest",
    icon:getImageIcon(serviceRequestIcon)
  },
  [FEATURE.SETTINGS]: {
    title: "Settings",
    path: "/setting",
    icon: getImageIcon(settingsIcon),
  },
  [FEATURE.COMPANY]: {
    title: "Company",
    path: "/company",
    icon: getImageIcon(companyIcon),
  },
  [FEATURE.ROLES]: {
    title: "Roles",
    path: "/roles",
    icon: getImageIcon(rolesIcon),
  },
  [FEATURE.CUSTOMERS]: {
    title: "Residents",
    path: "/customer",
    icon: getImageIcon(evDriversIcon),
  },
  [FEATURE.REFUND]: {
    title: "Refunds",
    path: "/refund",
    icon: getImageIcon(walletIcon),
  },
  CMCustomers: {
    title: "Customer",
    path: "/cm-customer",
    icon: getImageIcon(evDriversIcon),
  },
  [FEATURE.REPORT]: {
    title: "Report",
    path: "/report",
    icon: getImageIcon(reportIcon),
  },
  [FEATURE.CHARGEZONE]: {
    title: "Charge Zone",
    path: "/charge-zone",
    icon: getImageIcon(chargeZoneIcon),
  },
  [FEATURE.MEMBERS]: {
    title: "Members",
    path: "/management",
    icon: getImageIcon(MembersIcon),
  },
  [FEATURE.MAP]: {
    title: "Map",
    path: "/map",
    icon: getImageIcon(MapIcon),
  },
  [FEATURE.PRODUCT_LIST]: {
    title: "Product List",
    path: "/product-listing",
    icon: getImageIcon(ProductIcon),
  },
  [FEATURE.ZYNKA_SUITE]: {
    title: "Zynka Suite",
    path: "/zynka-suite",
    icon: getImageIcon(ProductIcon),
  },
  [FEATURE.THIRD_PARTY]: {
    title: "Third Party",
    path: "/third-party",
    icon: getImageIcon(settingsIcon),
  },
  [FEATURE.OCPI]: {
    title: "OCPI",
    path: "/ocpi/management",
    icon: getIcon("mdi:earth"),
  },
  [FEATURE.PROMOCODE]: {
    title: "Promo Codes",
    path: "/manage-promo-codes",
    icon: getImageIcon(promoCode),
  },
  [FEATURE.PAYOUT_HISTORY]: {
    title: "Payout History",
    path: "/payout-history",
    icon: getIcon("mdi:history"),
  },
  [FEATURE.FLEET_MANAGEMENT]: {
    title: "Fleet",
    path: "/fleet",
    icon: getImageIcon(evDriversIcon),
  },
  [FEATURE.MOBILE_CPO_ONBOARDING]: {
    title: "Mobile CPO Onboarding",
    path: "/mobile-cpo-onboarding",
    icon: getIcon("mdi:cellphone-cog"),
  },
};

export default sidebarConfig;
